/*rutas de Vendors*/
import Vendors from '@/apps/billing/views/Vendors';
export default [
	{
		path: 'vendors',
		name: 'Vendors',
		folder: Vendors,
	}
];
